import { render, staticRenderFns } from "./invalid-email-reset-token.vue?vue&type=template&id=504a828f&scoped=true&"
import script from "./invalid-email-reset-token.vue?vue&type=script&lang=js&"
export * from "./invalid-email-reset-token.vue?vue&type=script&lang=js&"
import style0 from "./invalid-email-reset-token.vue?vue&type=style&index=0&id=504a828f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a828f",
  null
  
)

export default component.exports